import React, { useEffect, useState } from 'react';
import VenoBox from 'venobox';
import siteQueries from '../../queries/siteQueries';
import { useScrollToTop } from '../../hooks/ScrollTop';
import Footer from './Footer';
import Pagination from '../../common/Pagination/Pagination';
import MainHeader from './MainHeader';
import Loader from './Loader';
import { BASE_URL } from '../../apis/api';
import BannerBg from '../../images/cover/inner-banner-bg.jpg';

export default function PhotoSiteListing() {
    const [gallery, setGallery] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [totalPage, setTotalPage] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const Gallery = siteQueries.useGalleryMutation((response) => {
        setGallery(response?.data?.items);
        setTotalCount(response?.data?.totalItems);
        setTotalPage(response?.data?.totalPages);
        setIsLoading(false);
    });

    useEffect(() => {
        Gallery.mutateAsync({ page: currentPage, size: pageSize });
    }, [currentPage, pageSize]);

    useEffect(() => {
        const venobox = new VenoBox({
            selector: '.photo-venobox',
            numeration: true,
            infinigall: true,
            share: true,
            spinner: 'rotating-plane',
            spinColor: '#F4D03F',
            titleattr: 'data-title',
            titlePosition: 'top',
            titleStyle: 'bar',
        });

        return () => { };
    }, [gallery]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    useEffect(() => {
        document.title = `Photogallery | International Literature Festival of Kerala 2025`;
        return () => {
            document.title = 'ILFK 2025 | International Lit Fest | Literature Festival | Literary Festival 2025';
        };
    }, []);

    useScrollToTop();

    return (
        <div className="min-h-screen bg-slate-50 from-gray-100 to-gray-200 photoGalleryContainer">
            <MainHeader />
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    {/* Banner */}
                    <div className="min-h-[190px] flex justify-center items-center text-bla py-4 relative overflow-hidden"
                        style={{
                            backgroundImage: `url(${BannerBg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                        }}>
                        <div className="relative z-5 text-center px-4">
                            <h1 className="text-4xl sm:text-2xl font-bold drop-shadow-md">
                                <span className="text-yellow-400 text-[36px]"> Photo Gallery </span>
                            </h1>
                            <p className="text-white text-[15px] sm:text-[18px] mt-2 font-semibold opacity-90">
                                Discover moments from the International Literature Festival of Kerala 2025
                            </p>
                        </div>
                    </div>

                    {/* Stats */}
                    <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
                        {/* Stats */}
                        <div className="text-left border-b p-4 mb-6">
                            <p className="text-gray-600 text-[16] text-[#000]">
                                Showing <span className="font-semibold">{gallery.length}</span> of{' '}
                                <span className="font-semibold">{totalCount}</span> photos
                            </p>
                        </div>
                    </div>

                    {/* Gallery */}
                    <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 pb-12 photoCards">
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                            {gallery?.map((image, index) => (
                                <a
                                    key={index}
                                    className="photo-venobox block rounded-lg overflow-hidden shadow-md hover:shadow-xl transition duration-300 bg-white"
                                    data-href={`${BASE_URL}/${image?.image}`}
                                    data-gall="gallery"
                                    data-fitview="true"
                                    data-title={image?.title}
                                >
                                    <img
                                        src={`${BASE_URL}/${image?.image}`}
                                        alt={image?.alt || image?.title}
                                        className="w-full h-48 object-cover"
                                    />
                                    <div className="p-3">
                                        <p className="text-sm text-gray-800 font-medium truncate">{image?.title}</p>
                                    </div>
                                </a>
                            ))}
                        </div>

                        {/* Pagination */}
                        <div className="flex justify-center mt-10">
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPage}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </>
            )}
            <Footer />
        </div>
    );
}
